<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="margin-top: 2%">
        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog"  style="z-index: 1058" persistent max-width="850px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Les produits de la commande : {{refCom}} </span>
                             <v-chip color="primary"
                                                style="color: white; cursor:pointer;margin-left: 15px">
                                           Total :  {{order.total_price}} XOF
                                        </v-chip>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-data-table
                                        :headers="headers2"
                                        :items="produitComs"
                                        :search="search"
                                        sort-by="name"
                                        class="elevation-1"
                                        :loading="produitComs.length==0" loading-text="Chargement en cours...">


                                    <template v-slot:item.produit_img="{item}">
                                        <a v-if="item.produit_img" :href="item.produit_img.substr(7)" target="_blank">
                                            <img :src="item.produit_img.substr(7)"
                                                 style="width: 50px; height: 50px;cursor: pointer; margin: 2% "
                                                 data-toggle="modal" data-target="#infos"/>
                                        </a>
                                    </template>

                                    <template v-slot:item.prix_achat="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat}} XOF</p>
                                    </template>


                                    <template v-slot:item._id="{ item }">
                                        <p style="font-weight: bold; font-size: 10pt">{{item.prix_achat * item.qte}}
                                            XOF</p>
                                    </template>




                                    <template v-slot:item.etat_get="{ item }">
                                        <v-chip :color="(item.etat_get!='false')?'green':'red'"
                                                style="color: white; cursor:pointer;">
                                            {{(item.etat_get=="false")?'En attente':'Déjà récupéré'}}
                                        </v-chip>
                                    </template>


                                    <template v-slot:no-data>
                                        <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                            <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                            <v-btn v-if="setgetorder" color="blue darken-1" text @click="save">Récupérer la commande</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

        </template>

        <v-card>
            <v-card-title>

                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher une commande ..."
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="precommandesEncours"
                    :search="search"
                    sort-by="name"
                    class="elevation-1"
                    :loading="precommandesEncoursloading" loading-text="Chargement en cours...">

                <template v-slot:item.reference="{ item }">
                    <v-chip @click="listProd(item)" color="#046089" style="color: white; cursor:pointer;">
                        <v-icon small class="mr-2">
                            mdi-eye
                        </v-icon>
                        {{ item.reference }}
                    </v-chip>
                </template>

                <template v-slot:item.state_paye="{ item }">
                    <v-chip :color="(item.state_paye=='SUCCESS')?'green':'orange'" style="color: white; cursor:pointer;">{{
                        item.state_paye }}
                    </v-chip>
                </template>
                <template v-slot:item.pharma_get="{ item }">
                    <v-chip :color="(item.pharma_get!='false')?'green':'red'" style="color: white; cursor:pointer;">
                        {{(item.pharma_get=="false")?'En attente':'Déjà récupéré'}}
                    </v-chip>
                </template>

                <template v-slot:item.pharma_total="{ item }">
                    <h5 style="font-weight: bold">{{item.pharma_total}} XOF</h5>
                </template>


                <template v-slot:item.created_at="{item}">
                    {{ getformatDate(item.created_at)}}
                </template>
                <template v-slot:no-data>
                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                </template>
            </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                timeout="2000"
        >
            {{ textSnack }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";


    export default {
        name: "Precommande",
        data() {
            return {
                submitting: false,
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                valid: true,
                lazy: false,
                errors: undefined,
                search: '',
                dialog: false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                refCom: '',
                pharma_total: 0,
                pharma_other_get: 'false',
                precommande: '',
                produitComs: '',
                setgetorder:false,
                order:"",
                headers: [
                    {
                        text: 'Référence',
                        align: 'start',
                        sortable: true,
                        value: 'reference',
                    },
                    {text: 'Client', value: 'client_slug.name', sortable: false},
                    {text: 'Contact d\'urgence', value: 'phone_client', sortable: false},
                    {text: 'Etat paiement', value: 'state_paye', sortable: false},
                    {text: 'Réception client', value: 'pharma_get', sortable: false},
                    {text: 'Montant payé', value: 'pharma_total', sortable: false},
                    {text: 'Date', value: 'created_at', sortable: false},

                ],
                headers2: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'produit_img',
                    },
                    {text: 'Produit', value: 'produit_name', sortable: false},
                    {text: 'Prix d\'achat', value: 'prix_achat', sortable: false},
                    {text: 'Quantité', value: 'qte', sortable: false},
                    {text: 'Réception client', value: 'etat_get', sortable: false},
                    {text: 'Sous Total', value: '_id', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                }

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('precommandes/', ['precommandesEncours','precommandesEncoursloading'])

        }
        ,
        mounted() {
         if (this.user.type_compte == "pharmacie")
            {
                 if (this.roles.includes("VCM")){
                   this.setgetorder = true;
                }
            }else{ this.$router.push("permission");}

            let data = new FormData();
            data.append("state_client_get", "false");
            data.append("pharma_get", "false");
            data.append("pharmacie", this.user.relation._id);
            this.$store.dispatch('precommandes/getPrecommandeCours', data).then(response => {
                window.console.log('precommandes', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            listProd(item) {
                
                 this.order = item;
                this.produitComs = item.all_precommande_produit;
                this.refCom = item.reference;
                this.pharma_total = item.pharma_total;
                this.pharma_other_get = item.pharma_other_get;
                this.precommande = item._id;
                this.dialog = true;
                console.log("this.order ",this.order );
            }
            ,
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
               // this.$refs.form.reset()
            },
            save() {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir confirmé cette commande ? L'action est irréversible.",
                    confirmButtonText: "Oui, je confirme",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                })
                    .then(result => {
                        if (result.value) {
                            this.submitting = true;
                            let tabId = [];
                            let tabProdId = [];
                            let tabProdQte = [];
                            for (let i = 0; i < this.produitComs.length; i++) {
                                tabId[i] = this.produitComs[i]._id;
                                tabProdId[i] = this.produitComs[i].produit_slug;
                                tabProdQte[i] = this.produitComs[i].qte;
                            }


                            let data = new FormData();
                            data.append("tab", JSON.stringify(tabId));
                            data.append("tabProd", JSON.stringify(tabProdId));
                            data.append("tabProdQte", JSON.stringify(tabProdQte));
                            data.append("user", this.user._id);
                            data.append("state_client_get", "false");
                            data.append("pharmacie", this.user.relation._id);
                            data.append("pharma_get", "false");
                            data.append("origin", this.order.origin);
                            data.append("pharma_total", this.pharma_total);
                            data.append("pharma_other_get", this.pharma_other_get);
                            data.append("precommande", this.precommande);
                            let mineroute = 'precommandes/setPrecommandeCours';
                            this.$store.dispatch(mineroute, data).then((response) => {
                                console.log('response', response);
                                this.snackbar = true;
                                this.textSnack = response.data.message;
                                this.submitting = false;
                                if (response.error) {
                                    this.errors.operation = response.data.message;
                                } else {
                                   this.dialog = false;
                                }
                            });
                           // this.dialog = false;
                        }
                    })



            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>